// Property uploader constants
export const PROPERTY_UPLOADER_IDS = {
  AGENTBOX: 'agentbox',
  AGENTPOINT: 'agentpoint',
  BOX_DICE: 'box-dice',
  CENTURY21_ESALES: 'century21-esales',
  DOMAIN_API: 'domain-api',
  EAGLE_SOFTWARE: 'eagle-software',
  IDASHBOARD: 'idashboard',
  KOLMEO: 'kolmeo',
  LISTONCE: 'listonce',
  LOCKEDON: 'lockedon',
  MULTIARRAY: 'multiarray',
  MYDESKTOP: 'mydesktop',
  PROPERTYME: 'propertyme',
  RENET: 'renet',
  REST_LIMITED: 'rest-limited',
  REX_SOFTWARE: 'rex-software',
  MRI_VAULT_CRM: 'mri-vault-crm',
  ZENU: 'zenu',
}

export const PROPERTY_UPLOADER_NAMES = {
  AGENTBOX: 'Agentbox',
  AGENTPOINT: 'AgentPoint',
  BOX_DICE: 'Box+Dice',
  CENTURY21_ESALES: 'Century21 eSales',
  DOMAIN_API: 'Domain API (requires Paid Plan & Integrations Bundle)',
  EAGLE_SOFTWARE: 'Eagle Software',
  IDASHBOARD: 'iDashboard',
  KOLMEO: 'Kolmeo',
  LISTONCE: 'ListOnce',
  LOCKEDON: 'LockedOn',
  MULTIARRAY: 'MultiArray',
  MYDESKTOP: 'MyDesktop',
  PROPERTYME: 'PropertyMe',
  RENET: 'ReNet',
  REST_LIMITED: 'REST (limited)',
  REX_SOFTWARE: 'Rex Software',
  MRI_VAULT_CRM: 'MRI Vault CRM',
  ZENU: 'Zenu',
}

// Property uploader options for the Connect Property Uploader section
export const PROPERTY_UPLOADERS = [
  {
    id: PROPERTY_UPLOADER_IDS.AGENTBOX,
    name: PROPERTY_UPLOADER_NAMES.AGENTBOX,
  },
  {
    id: PROPERTY_UPLOADER_IDS.AGENTPOINT,
    name: PROPERTY_UPLOADER_NAMES.AGENTPOINT,
  },
  {
    id: PROPERTY_UPLOADER_IDS.BOX_DICE,
    name: PROPERTY_UPLOADER_NAMES.BOX_DICE,
  },
  {
    id: PROPERTY_UPLOADER_IDS.CENTURY21_ESALES,
    name: PROPERTY_UPLOADER_NAMES.CENTURY21_ESALES,
  },
  {
    id: PROPERTY_UPLOADER_IDS.DOMAIN_API,
    name: PROPERTY_UPLOADER_NAMES.DOMAIN_API,
  },
  {
    id: PROPERTY_UPLOADER_IDS.EAGLE_SOFTWARE,
    name: PROPERTY_UPLOADER_NAMES.EAGLE_SOFTWARE,
  },
  {
    id: PROPERTY_UPLOADER_IDS.IDASHBOARD,
    name: PROPERTY_UPLOADER_NAMES.IDASHBOARD,
  },
  { id: PROPERTY_UPLOADER_IDS.KOLMEO, name: PROPERTY_UPLOADER_NAMES.KOLMEO },
  {
    id: PROPERTY_UPLOADER_IDS.LISTONCE,
    name: PROPERTY_UPLOADER_NAMES.LISTONCE,
  },
  {
    id: PROPERTY_UPLOADER_IDS.LOCKEDON,
    name: PROPERTY_UPLOADER_NAMES.LOCKEDON,
  },
  {
    id: PROPERTY_UPLOADER_IDS.MULTIARRAY,
    name: PROPERTY_UPLOADER_NAMES.MULTIARRAY,
  },
  {
    id: PROPERTY_UPLOADER_IDS.MYDESKTOP,
    name: PROPERTY_UPLOADER_NAMES.MYDESKTOP,
  },
  {
    id: PROPERTY_UPLOADER_IDS.PROPERTYME,
    name: PROPERTY_UPLOADER_NAMES.PROPERTYME,
  },
  { id: PROPERTY_UPLOADER_IDS.RENET, name: PROPERTY_UPLOADER_NAMES.RENET },
  {
    id: PROPERTY_UPLOADER_IDS.REST_LIMITED,
    name: PROPERTY_UPLOADER_NAMES.REST_LIMITED,
  },
  {
    id: PROPERTY_UPLOADER_IDS.REX_SOFTWARE,
    name: PROPERTY_UPLOADER_NAMES.REX_SOFTWARE,
  },
  {
    id: PROPERTY_UPLOADER_IDS.MRI_VAULT_CRM,
    name: PROPERTY_UPLOADER_NAMES.MRI_VAULT_CRM,
  },
  { id: PROPERTY_UPLOADER_IDS.ZENU, name: PROPERTY_UPLOADER_NAMES.ZENU },
]
